import { render, staticRenderFns } from "./sk_kepala_daerah.vue?vue&type=template&id=3643dc33&"
import script from "./sk_kepala_daerah.vue?vue&type=script&lang=js&"
export * from "./sk_kepala_daerah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports